// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DRAhq","label":"styles_label__1TySp"};